module.exports = __webpack_public_path__ + "static/media/gamesWon_25000_100000.5e779799.png";